/*
 * @Author: Shirtiny
 * @Date: 2021-08-18 15:20:08
 * @LastEditTime: 2021-08-18 18:14:01
 * @Description:
 */

import React, { useCallback, useEffect, useMemo, useRef } from "react";
import { css } from "styled-components";

const DragOverAttributeName = "dragovering";

const DropArea = ({ enable = false, children, onDropFile }) => {
  const dropAreaRef = useRef(null);

  const handleDragOver = useCallback(() => {
    const el = dropAreaRef.current;
    el.setAttribute(DragOverAttributeName, 1);
  }, []);

  const handleDragEnd = useCallback(() => {
    const el = dropAreaRef.current;
    el.removeAttribute(DragOverAttributeName);
  }, []);

  // 松开鼠标时将文件传给onchange 并修改input的value为fileName 以实现默认的fileInput行为
  const handleDrop = useCallback(
    (e) => {
      e.preventDefault();
      const files = e.dataTransfer.files;
      if (files.length) {
        onDropFile && onDropFile(files);
      }
      handleDragEnd();
    },
    [handleDragEnd, onDropFile]
  );

  const bindFileListeners = useCallback(() => {
    if (enable) {
      const el = dropAreaRef.current;
      el.addEventListener("drop", handleDrop);
      el.addEventListener("dragover", handleDragOver);
      el.addEventListener("dragend", handleDragEnd);
      el.addEventListener("dragleave", handleDragEnd);
    }
  }, [enable, handleDragEnd, handleDragOver, handleDrop]);

  const removeFileListeners = useCallback(() => {
    const el = dropAreaRef.current;
    if (enable && el) {
      el.removeEventListener("drop", handleDrop);
      el.removeEventListener("dragover", handleDragOver);
      el.removeEventListener("dragend", handleDragEnd);
      el.removeEventListener("dragleave", handleDragEnd);
    }
  }, [enable, handleDragEnd, handleDragOver, handleDrop]);

  useEffect(() => {
    bindFileListeners();

    return () => {
      removeFileListeners();
    };
  }, [bindFileListeners, removeFileListeners]);

  const areaCss = useMemo(() => {
    return enable
      ? css`
          position: relative;
          user-select: none;
          &:before {
            content: "";
            position: absolute;
            z-index: -1;
            top: -8px;
            left: -8px;
            right: -8px;
            bottom: -8px;
            border: 1px dashed transparent;
            transition: border-color 0.3s;
          }
          &[dragovering] {
            :before {
              border-color: #6a737d;
            }
          }
        `
      : "";
  }, [enable]);

  return <>{children({ dropAreaRef, areaCss })}</>;
};

export default DropArea;
